<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <b-col lg="2" >
                <label class="some-label" for="select-building">Building</label>
                <b-form-select id="select-building" v-model="selectedBuilding" :options="buildingOptions"></b-form-select>
              </b-col>
              <b-col lg="2" >
                <label class="some-label" for="select-status">Ownership Status</label>
                <b-form-select id="select-status" v-model="selectedStatus" :options="statusOptions"></b-form-select>
              </b-col>
              <b-col lg="2" >
                <label class="some-label" for="select-payment-status">Payment Status</label>
                <b-form-select id="select-payment-status" v-model="selectedPaymentStatus" :options="paymentStatusOptions"></b-form-select>
              </b-col>
              <b-col lg="2">
                <label for="owner-phone">Owner Phone</label>
                <b-form-input v-model="ownerPhone" id="owner-phone" size="sm" placeholder="Owner Phone"></b-form-input>
              </b-col>
              <b-col lg="1" class="mt-4">
                <b-button class="btn-secondary" id="filter-btn" @click="getReport()">Find</b-button>
              </b-col>
              <b-col lg="1" class="mt-4">
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" title="Export to excel"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                    <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" title="Export to Pdf"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                  </b-button-group>
                </b-button-toolbar>
              </b-col>
              </b-row>
              <!-- <b-row>
              <b-col lg="8" class="my-1"></b-col>
             <b-col lg="4" class="my-1">
              <label for="datepicker-invalid3"></label>
                  <b-form-group class="mb-0" id="datepicker-invalid3">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row> -->
            </template>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 450px; overflow-y: auto;"
              striped
              responsive
              hover
              class="table-responsive"
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Payment Id</b-th>
                  <b-th>Owner Name</b-th>
                  <b-th>Owner Phone</b-th>
                  <b-th>Building</b-th>
                  <b-th>House</b-th>
                  <b-th>Ownership Status</b-th>
                  <b-th>Repayment Amount</b-th>
                  <b-th>Paid Amount</b-th>
                  <b-th>Unpaid Amount</b-th>
                  <b-th>Payment Status</b-th>
                  <b-th>Payment Date</b-th>
                  <b-th>Penalty Amount</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr >
                        <b-td colspan="12" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                        </b-td>
                      </b-tr>
                  </b-tbody>
              </template>
              <template v-else>
                <template v-if="filterTable.length === 0" >
                <b-tbody>
                  <b-tr>
                      <b-td colspan="12" class="text-center">Nothing found</b-td>
                    </b-tr>
                    </b-tbody>
                </template>
                <template v-else>
                <b-tbody>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.uniqueId}}</b-td>
                      <b-td>{{item.ownerFullName}}</b-td>
                      <b-td>{{item.ownerPhoneNumber}}</b-td>
                      <b-td>{{item.buildingName}}</b-td>
                      <b-td>{{item.floor}} - {{item.roomNumber}}</b-td>
                      <b-td>{{item.ownershipStatus}}</b-td>
                      <b-td>{{numberWithCommas(item.repaymentAmount)}}</b-td>
                      <b-td>{{numberWithCommas(item.paidTotalAmount)}}</b-td>
                      <b-td>{{numberWithCommas(item.unpaidTotalAmount)}}</b-td>
                      <b-td>
                        <span :class="item.paymentStatus === 'Paid' ? 'text-success' : 'text-danger'">
                          {{item.paymentStatus}}
                        </span>
                      </b-td>
                      <b-td>{{item.paymentDate}}</b-td>
                      <b-td>{{numberWithCommas(item.penaltyAmount)}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="11" class="text-right" style="font-weight: bold;">Total Collected Payment (ETB)</b-td>
                    <b-td style="font-weight: bold;">{{numberWithCommas(totalCollectedPayment)}}</b-td>
                  </b-tr>
              </b-tbody>
                </template>
              </template>
            </b-table-simple>
            <div style="margin-bottom: 20px;"></div>
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
            </b-row> 
           </card>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Fix footer overlapping issues */
.content-wrapper {
  padding-bottom: 20px;
  min-height: calc(100vh - 120px);
}

.table-container {
  margin-bottom: 15px;
}

.pagination-container {
  margin-bottom: 10px;
  padding-bottom: 10px;
}

/* Ensure proper spacing for all table components */
.card {
  margin-bottom: 15px;
}

/* Fix table responsiveness */
.table-responsive {
  margin-bottom: 10px;
}
</style>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable';
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        statusOptions:[
          {text: "All", value: ""},
          {text: "Owned", value: "Owned"},
          {text: "Rented", value: "Rented"}
        ],
        paymentStatusOptions:[
          {text: "All", value: ""},
          {text: "Paid", value: "Paid"},
          {text: "Unpaid", value: "Unpaid"}
        ],
        selectedPaymentStatus: "",
        ownerPhone: "",
        buildingOptions: [
          {text: "All", value: ""},
        ],
        selectedBuilding: "",
        selectedStatus: "",
        dataExcel: [],
        totalCollectedPayment: 0.0,
        spinner: true
      }
    },
    computed: {
      filterTable() {
        var searchItems = this.items || [];
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.ownerFullName.toLowerCase().indexOf(searchString) !== -1 || item.ownerPhoneNumber.toLowerCase().indexOf(searchString) !== -1 || (String(item.floor).toLowerCase() + " - " + item.roomNumber.toLowerCase()).indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getReport();
      this.getBuildings();
      this.$on("AfterComplete", () => {
        this.getReport();
      });
    },
    methods: {
      getBuildings(){
         this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined ){
            x= parseFloat(x);
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          return null;
        }
      },
       getReport(){
        this.spinner = true;
        const params = {
          userId: parseInt(sessionStorage.getItem("ID")), 
          page: this.currentPage, 
          line: this.perPage
        };
        if (this.selectedBuilding && this.selectedBuilding !== "") params.buildingId = this.selectedBuilding;
        if (this.ownerPhone) params.phoneNumber = this.ownerPhone;
        if (this.selectedStatus && this.selectedStatus !== "") params.ownershipStatus = this.selectedStatus;
        if (this.selectedPaymentStatus) params.paymentStatus = this.selectedPaymentStatus;
        this.$store.dispatch('getHouseOwnerReport', params)
          .then(response=>{
              this.items = response.data.history || [];
              this.totalRows = response.data.totalElements || 0;
              this.totalCollectedPayment = response.data.totalCollectedAmount || 0;
          })
          .catch(error=>{
              this.items = [];
              this.totalRows = 0;
              this.totalCollectedPayment = 0;
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      changePage(event, page){
        this.currentPage = page;
        this.getReport();
      },
      changePerPage(event){
        this.currentPage = 1;
        this.getReport();
      },
      async getDataForExcel(){
        this.dataExcel = [];
        const params = {
          userId: parseInt(sessionStorage.getItem("ID")), 
          page: 1, 
          line: this.totalRows
        };
        if (this.selectedBuilding !== "All") params.buildingId = this.selectedBuilding;
        if (this.ownerPhone) params.phoneNumber = this.ownerPhone;
        if (this.selectedStatus !== "All") params.ownershipStatus = this.selectedStatus;
        if (this.selectedPaymentStatus) params.paymentStatus = this.selectedPaymentStatus;
        try {
          const response = await this.$store.dispatch('getHouseOwnerReport', params);
          if (response.data.history && response.data.history.length > 0) {
            let index = 0;
            response.data.history.forEach(x => {
              index++;
              this.dataExcel.push({
                No: index,
                Owner_Name: x.ownerFullName,
                Owner_Phone: x.ownerPhoneNumber,
                Building_Name: x.buildingName,
                Floor: x.floor,
                Room_Number: x.roomNumber,
                Ownership_Status: x.ownershipStatus,
                Repayment_Amount: x.repaymentAmount,
                Paid_Amount: x.paidTotalAmount,
                Unpaid_Amount: x.unpaidTotalAmount,
                Payment_Status: x.paymentStatus,
                Payment_Date: x.paymentDate,
                Penalty_Amount: x.penaltyAmount
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
        
        if (this.dataExcel.length > 0) {
          const filename = 'House Owner Report.csv';
          const csvData = this.convertToCSV(this.dataExcel);
          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        } else {
          this.$notifications.notify({
            message: "Nothing to export",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      },
      convertToCSV(jsonData) {
        const header = Object.keys(jsonData[0]).join(',');
        const rows = jsonData.map(row => Object.values(row).join(','));
        return `${header}\n${rows.join('\n')}`;
      },
      async getDataForPDF(){
        this.dataExcel = [];
        const params = {
          userId: parseInt(sessionStorage.getItem("ID")), 
          page: 1, 
          line: this.totalRows
        };
        if (this.selectedBuilding !== "All") params.buildingId = this.selectedBuilding;
        if (this.ownerPhone) params.phoneNumber = this.ownerPhone;
        if (this.selectedStatus !== "All") params.ownershipStatus = this.selectedStatus;
        if (this.selectedPaymentStatus) params.paymentStatus = this.selectedPaymentStatus;
        
        try {
          const response = await this.$store.dispatch('getHouseOwnerReport', params);
          if (response.data.history && response.data.history.length > 0) {
            let index = 0;
            response.data.history.forEach(x => {
              index++;
              this.dataExcel.push({
                No: index,
                Owner_Name: x.ownerFullName,
                Owner_Phone: x.ownerPhoneNumber,
                Building_Name: x.buildingName,
                Floor: x.floor,
                Room_Number: x.roomNumber,
                Ownership_Status: x.ownershipStatus,
                Repayment_Amount: x.repaymentAmount,
                Paid_Amount: x.paidTotalAmount,
                Unpaid_Amount: x.unpaidTotalAmount,
                Payment_Status: x.paymentStatus,
                Payment_Date: x.paymentDate,
                Penalty_Amount: x.penaltyAmount
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
        
        if (this.dataExcel.length > 0) {
          var pdf = new jsPDF({ orientation: 'landscape' });
          let headers = Object.keys(this.dataExcel[0]);
          let rows = this.dataExcel.map(obj => Object.values(obj));
          
          pdf.autoTable({
            head: [headers],
            body: rows,
            styles: { fontSize: 8.5 },
            headStyles: {
              fillColor: [37, 91, 48],
              textColor: [240, 206, 13],
              fontSize: 9
            }
          });
          
          pdf.save("House_Owner_Report.pdf");
        } else {
          this.$notifications.notify({
            message: "Nothing to export",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      },
      clearData(){
        this.$emit('AfterComplete');
      }
    }
  }
</script>
<style>
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
</style>